/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { Box, Button, Link, Typography } from '@material-ui/core'
import { Star } from '@material-ui/icons'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ArrowRight } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import noDataImage from '../../../../assets/images/no-program.svg'
import UploadImg from '../../../../assets/images/upload-logo.png'
import { ROUTES } from '../../../../helpers/constants'
import { getSchoolUrl, isNullOrEmpty, noop } from '../../../../helpers/utils'
import withRedirect from '../../../../hocs/RedirectHOC'
import CommonPagination from '../../../common/CommonPagination'
import useStyles from '../allEnrollments/ProgramCourses.Style'
import RouterContext from './../../../../contexts/route.context'

function AvailableProgramsList({
  pageDetails,
  availableProgramList,
  onChangePage,
  enrollProgram,
  readOnlyMode,
  metadata,
  // redirectToPrograms,
}) {
  const { t } = useTranslation()
  const classes = useStyles()
  const ButtonEnhanced = withRedirect(Button)
  const [showMore, setShowMore] = React.useState<string[]>([])
  const history = useHistory()
  const { params } = useContext(RouterContext)

  const redirectToPrograms = function (row) {
    history.push(getSchoolUrl({ ...params, to: `${ROUTES.PROGRAMDETAILOPEN}/${row.pgm_id}` }))
  }

  const redirectToProgramsForStateFund = (pgm_id) => {
    // history.push(getSchoolUrl({ ...params, to: `${ROUTES.PROGRAMDETAILOPEN}/${pgm_id}` }))

    history.push({
      pathname: getSchoolUrl({
        ...params,
        to: `${ROUTES.AVAILABLEPROGRAMDETAILS}/${pgm_id}`,
      }),
    })
  }

  const moreTextHandler = (id) => {
    if (showMore.includes(id)) {
      const tempShowMore = showMore.filter((showId) => showId !== id)
      setShowMore(tempShowMore)
    } else {
      setShowMore([...showMore, id])
    }
  }
  console.log(metadata, 'metadata')
  const getDescription = (row) => {
    let displayContent

    if (showMore.includes(row.pgm_id)) {
      displayContent = row.pgm_short_description ? row.pgm_short_description : row.pgm_description
    } else {
      displayContent = row?.pgm_short_description
        ? `${row.pgm_short_description.slice(0, 300)}`
        : `${row.pgm_description.slice(0, 300)}`
    }

    let ellipsisContent = ''

    if (!showMore.includes(row.pgm_id)) {
      if (row?.pgm_short_description) {
        ellipsisContent = row.pgm_short_description.length >= 300 ? '...' : ''
      } else if (row?.pgm_description) {
        ellipsisContent = row.pgm_description.length >= 300 ? '...' : ''
      }
    }

    return `${displayContent}${ellipsisContent}`
  }

  const detailsTranslationKey = (row) => {
    return showMore.includes(row.pgm_id) ? 'lessDetails' : 'moreDetails'
  }
  return (
    <>
      {availableProgramList.map((row) => {
        const programCategory = row?.pgm_program_category?.pct_color_hex
        return (
          <Box
            className="program-list"
            p={2}
            display="flex"
            alignItems="flex-start"
            justifyContent="flex-start"
            flexDirection={{ xs: 'column', sm: 'row' }}
            key={row.pgm_id}
            position={'relative'}
          >
            {row?.context_data?.publish_aggregated_ratings &&
              !isNullOrEmpty(row?.aggregateRating) &&
              row?.aggregateRating > 0 &&
              ((row?.context_data?.public_program_list && readOnlyMode) ||
                (row?.context_data?.available_programs && !readOnlyMode)) && (
                <Box position={'absolute'} right={'16px'}>
                  <Box color={'var(--color-star-orange)'} display={'flex'} alignItems={'center'}>
                    <Star width={24} height={24} />
                    <Typography component="span" variant="body1">
                      <Box fontSize={'16px'} color={'var(--color-grey-1)'} fontWeight={500}>
                        {row?.aggregateRating}
                      </Box>
                    </Typography>
                    <Typography component="span" variant="body1">
                      <Box ml={1} fontSize={'14px'} color={'var(--color-grey-3)'} fontWeight={400}>
                        ({row?.totalRatings} {t('rating')})
                      </Box>
                    </Typography>
                  </Box>
                </Box>
              )}
            <Box
              sx={{
                '&:before': {
                  backgroundColor: programCategory,
                },
              }}
              className={clsx(classes.programImage, classes.programCategory)}
              mb={{ xs: 2, md: 0 }}
            >
              <Box
                mx="auto"
                width="112px"
                height="112px"
                borderRadius={8}
                className="image-container"
              >
                <img
                  src={row.pgm_logo || UploadImg}
                  alt="program"
                  onError={(e) => {
                    e.target.onerror = null
                    e.target.src = UploadImg
                  }}
                />
              </Box>
            </Box>

            <Box className={classes.completedProgram} pl={{ xs: 0, sm: 3 }}>
              <Typography component="h4" variant="body1" tabIndex={0}>
                {readOnlyMode ? (
                  <Box
                    fontWeight={600}
                    className="link-color-text cursor-pointer"
                    onClick={() => (readOnlyMode ? redirectToPrograms(row) : noop)}
                  >
                    {row.pgm_name}
                  </Box>
                ) : (
                  <Box fontWeight={600}>{row.pgm_name}</Box>
                )}
              </Typography>

              <Typography
                component="h6"
                align="left"
                variant="subtitle2"
                color="textPrimary"
                gutterBottom
              >
                <Box
                  component="span"
                  fontWeight="fontWeightMedium"
                  fontSize="12px"
                  className="word-break"
                >
                  {getDescription(row)}
                  {row.pgm_short_description
                    ? row?.pgm_short_description?.length >= '300' && (
                        <Box component="span" fontWeight="fontWeightBold" ml={1}>
                          <Link
                            className="text-info cursor-pointer"
                            component="a"
                            onClick={() => moreTextHandler(row.pgm_id)}
                            key={row.pgm_id}
                          >
                            {t(detailsTranslationKey(row))}
                          </Link>
                        </Box>
                      )
                    : row?.pgm_description?.length >= '300' && (
                        <Box component="span" fontWeight="fontWeightBold" ml={1}>
                          <Link
                            className="text-info cursor-pointer"
                            component="a"
                            onClick={() => moreTextHandler(row.pgm_id)}
                            key={row.pgm_id}
                          >
                            {t(detailsTranslationKey(row))}
                          </Link>
                        </Box>
                      )}
                </Box>
              </Typography>

              <Box
                display="flex"
                alignItems={{ xs: 'flex-start', sm: 'center' }}
                justifyContent="space-between"
                width="100%"
              >
                {/* <Rating size="small" name="rating" value={5} /> */}

                <Box
                  display="flex"
                  alignItems={{ xs: 'flex-start', sm: 'flex-end' }}
                  justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}
                >
                  {readOnlyMode && (
                    <ButtonEnhanced
                      className="custom-default-button text-transform-none manual-spacing"
                      variant="contained"
                      disableElevation
                      color="primary"
                      to={
                        metadata?.enr_pgm_selection === 'pre-registration'
                          ? `${ROUTES.PROGRAMDETAILOPEN}/${row.pgm_id}`
                          : `${ROUTES.PROGRAMDETAILOPEN}/${row.pgm_id}`
                      }
                    >
                      {t('viewDetail')}
                    </ButtonEnhanced>
                  )}

                  {readOnlyMode && metadata?.enr_pgm_selection === 'pre-registration' && (
                    <Button
                      className="text-transform-none"
                      variant="contained"
                      disableElevation
                      color="primary"
                      endIcon={<ArrowRight width={16} height={16} />}
                      onClick={() => enrollProgram(row.pgm_id)}
                      // onClick={() => enrollProgram(row.pgm_id)}
                    >
                      {t('enrollNow')}
                    </Button>
                  )}
                  {!readOnlyMode && (
                    <ButtonEnhanced
                      className="text-transform-none availablePrograms-tour-step1"
                      variant="contained"
                      disableElevation
                      color="primary"
                      endIcon={<ArrowRight width={16} height={16} />}
                      to={`${ROUTES.AVAILABLEPROGRAMDETAILS}/${row.pgm_id}`}
                    >
                      {t('enrollNow')}
                    </ButtonEnhanced>
                  )}

                  {window.location.pathname.includes('/accessibleprograms') && readOnlyMode && (
                    <Button
                      className="text-transform-none"
                      variant="contained"
                      disableElevation
                      color="primary"
                      endIcon={<ArrowRight width={16} height={16} />}
                      // onClick={() => enrollProgram(row.pgm_id)}
                      onClick={() => redirectToProgramsForStateFund(row.pgm_id)}
                    >
                      {t('enrollNow')}
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        )
      })}
      {availableProgramList.touched || availableProgramList.length == 0 ? (
        <Box
          p={5}
          dispaly="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
        >
          <Box mb={3} display="flex" justifyContent="center" className="no-data-image">
            <img width="200px" src={noDataImage} alt="no data" />
          </Box>
          <Box
            component="p"
            fontSize="22px"
            fontWeight="600"
            align="center"
            className="custom-table-no-data"
          >
            {t('noAvailablePrograms')}
          </Box>
        </Box>
      ) : null}
      {availableProgramList.length > 0 ? (
        <Box
          display="flex"
          py={2}
          justifyContent={{ xs: 'flex-start', sm: 'flex-start' }}
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems="center"
          className="custom-pagination"
        >
          <CommonPagination
            count={pageDetails.last_page}
            onChange={onChangePage}
            page={pageDetails.current_page}
          />
          <Box mt={{ xs: 1, sm: 0 }}>
            <Typography component="p" variant="body2" tabIndex={0}>
              {t('showPageDetails', {
                results: availableProgramList.length,
                total: pageDetails.total,
              })}
            </Typography>
          </Box>
        </Box>
      ) : null}
    </>
  )
}

AvailableProgramsList.propTypes = {
  availableProgramList: PropTypes.array,
  pageDetails: PropTypes.object,
  onChangePage: PropTypes.func,
  enrollProgram: PropTypes.func,
  readOnlyMode: PropTypes.bool,
  metadata: PropTypes.object,
  redirectToPrograms: PropTypes.func,
}

AvailableProgramsList.defaultProps = {
  availableProgramList: [],
  pageDetails: {},
  onChangePage: noop,
  enrollProgram: noop,
  readOnlyMode: false,
  metadata: {},
  redirectToPrograms: noop,
}

export default AvailableProgramsList
